import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "../../lib/utils";

const badgeVariants = cva(
  "inline-flex max-w-full min-w-0 shrink-0 items-center gap-1 rounded-md border px-2 py-1 text-xs leading-none font-medium whitespace-nowrap transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {
  icon?: React.ReactNode;
}

function Badge({ className, variant, children, icon, title, ...props }: BadgeProps) {
  return (
    <span {...props} data-slot="badge" title={title}
      ref={(node) => { if (node && title === undefined) node.title = node.textContent ?? ""; }}
      className={cn(badgeVariants({ variant }), className)}>
      {icon ? <span aria-hidden="true" className="inline-flex h-3 w-3 shrink-0 items-center justify-center [&>svg]:size-3">{icon}</span> : null}
      <span className="badge-label min-w-0 truncate">{children}</span>
    </span>
  );
}

export { Badge, badgeVariants };
